module.exports = __webpack_public_path__ + "build/img/bonus-gift-sale.a036e23c.png";